import type { RouteRecordRaw } from "vue-router";

export const adminRoutes: RouteRecordRaw[] = [
  {
    path: "/admin/features",
    name: "admin-features",
    component: () => import("./features.vue"),
    meta: {
      requiresAuth: true,
      title: "admin.features.title",
      // Internal admin tooling — kept out of product page-view analytics.
      skipAnalytics: true,
    },
  },
  {
    // Feature-flag administration now lives in a tab on /admin/features.
    path: "/admin/feature_flags",
    redirect: { name: "admin-features" },
  },
];
